import { render, staticRenderFns } from "./PropertyMortgageFreeYN.vue?vue&type=template&id=127b12f8"
import script from "./PropertyMortgageFreeYN.vue?vue&type=script&lang=js"
export * from "./PropertyMortgageFreeYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports